'use client';

import { Modal } from './Modal';

export interface DirectMessageModalLabels {
  title: string;
  subtitle: string;
  subjectLabel: string;
  subjectPlaceholder: string;
  bodyLabel: string;
  bodyPlaceholder: string;
  cancel: string;
  send: string;
  sending: string;
}

interface DirectMessageModalProps {
  isOpen: boolean;
  onClose: () => void;
  subject: string;
  onSubjectChange: (value: string) => void;
  body: string;
  onBodyChange: (value: string) => void;
  sending: boolean;
  onSend: () => void;
  labels: DirectMessageModalLabels;
}

export function DirectMessageModal({
  isOpen,
  onClose,
  subject,
  onSubjectChange,
  body,
  onBodyChange,
  sending,
  onSend,
  labels,
}: DirectMessageModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={labels.title}
      subtitle={labels.subtitle}
      footer={
        <>
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-sm border border-border rounded-md text-foreground hover:bg-background-secondary"
            data-testid="dm-modal-cancel-btn"
          >
            {labels.cancel}
          </button>
          <button
            type="button"
            onClick={onSend}
            disabled={sending}
            className="px-4 py-2 text-sm bg-primary text-background rounded-md hover:opacity-90 disabled:cursor-not-allowed"
            data-testid="dm-modal-send-btn"
          >
            {sending ? labels.sending : labels.send}
          </button>
        </>
      }
    >
      <div className="space-y-4" data-testid="dm-modal-root">
        <div>
          <label className="block text-sm font-medium text-foreground mb-1.5">
            {labels.subjectLabel} *
          </label>
          <input
            type="text"
            value={subject}
            onChange={(e) => onSubjectChange(e.target.value)}
            placeholder={labels.subjectPlaceholder}
            className="w-full px-3 py-2 border border-border rounded-md text-foreground bg-background focus:outline-none focus:ring-2 focus:ring-primary"
            data-testid="dm-modal-subject"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-foreground mb-1.5">
            {labels.bodyLabel} *
          </label>
          <textarea
            value={body}
            onChange={(e) => onBodyChange(e.target.value)}
            placeholder={labels.bodyPlaceholder}
            rows={6}
            className="w-full px-3 py-2 border border-border rounded-md text-foreground bg-background focus:outline-none focus:ring-2 focus:ring-primary resize-none"
            data-testid="dm-modal-body"
          />
        </div>
      </div>
    </Modal>
  );
}
